module.exports = __webpack_public_path__ + "static/media/aion-wing-overlay.a9d9db0a.png";